import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getSocialmedia } from "../../features/socialmedia/Slice";
import { postSubscriber } from "../../features/home/homeSlice";
import { appSetup } from "../../features/master/masterSlice";
import Book_appointment_modal from "../common-components/common-modals/book-appointment-modal/Book_appointment_modal";

const Footer = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState(null);
  const navigate = useNavigate();

  const medias = useSelector((state) => state.socialmedia.addSocialmedia);
  const appsetup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(getSocialmedia());
    dispatch(appSetup());
  }, [dispatch]);

  const hasMap = appsetup?.lat && appsetup?.long;
  const smallMapSrc = `https://www.google.com/maps?q=${appsetup?.lat},${appsetup?.long}&hl=en&z=14&output=embed`;
  const bigMapSrc = `https://www.google.com/maps?q=${appsetup?.lat},${appsetup?.long}&hl=en&z=16&output=embed`;

  const SUPPORT_LINKS = [
    { label: "Bapat Benefits", to: "/bapat-benefits" },
    { label: "Bapat Academy", to: "/bapat-academy" },
    { label: "Refer a friend", to: "/bapat-benefits" },
    { label: "Reward System", to: "/my-account" },
    { label: "Shipping Policy", to: "/shipping-policy" },
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Terms & Conditions", to: "/terms-conditions" },
  ];

  const CONTACT_LINKS = [
    { label: "Careers", to: "/career" },
    { label: "Track Your Order", to: "/my-account" },
    { label: "About Us", to: "/about-us" },
    { label: "Contact Us", to: "/contact-us" },
  ];

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await dispatch(postSubscriber({ data: { email } })).unwrap();
      setSubscribeStatus("success");
      setEmail("");
    } catch (err) {
      setSubscribeStatus("error");
    }
  };

  return (
    <>
      <section className="Footer">
        {/* full-width container: the columns now reach both edges */}
        <div className="footer_container">
          <div className="content_div">
            <div className="footer_grid">
              {/* Support */}
              <div className="footer_col">
                <div className="link_div">
                  <h3 className="heading_text">Support</h3>
                  <ul className="about_ul">
                    {SUPPORT_LINKS.map((item) => (
                      <li key={item.label}>
                        <Link className="link_text heading" to={item.to}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Contact (with small map below the links) */}
              <div className="footer_col">
                <div className="link_div">
                  <h3 className="heading_text">Contact</h3>
                  <ul className="about_ul">
                    {CONTACT_LINKS.map((item) => (
                      <li key={item.label}>
                        {item.href ? (
                          <a className="link_text heading" href={item.href}>
                            {item.label}
                          </a>
                        ) : (
                          <Link className="link_text heading" to={item.to}>
                            {item.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>

                  {hasMap && (
                    <div
                      className="footer_map_small"
                      role="button"
                      tabIndex={0}
                      title="Click to enlarge map"
                      onClick={() => setMapOpen(true)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setMapOpen(true);
                        }
                      }}
                    >
                      <iframe
                        className="footer_map_iframe"
                        title="Bapat Optics location"
                        src={smallMapSrc}
                        loading="lazy"
                        frameBorder="0"
                        scrolling="no"
                      ></iframe>
                      <span className="footer_map_hint">Click to enlarge</span>
                    </div>
                  )}
                </div>
              </div>

              {/* About The Shop */}
              <div className="footer_col">
                <div className="link_div about_shop_div">
                  <h3 className="heading_text">About The Shop</h3>
                  <p className="info_text">
                    Welcome to Bapat Optics. For over 20 years, we have
                    provided comprehensive precision eye care built on trust
                    and expertise. As a partnered ZEISS Vision Center, we
                    deliver exceptional accuracy in vision assessment and lens
                    customization. Discover our extensive collection of
                    premium eyewear, featuring trusted international brands,
                    prescription spectacles, sunglasses, and children's
                    options designed for perfect comfort and style.
                  </p>
                </div>
              </div>

              {/* Join The Club */}
              <div className="footer_col">
                <div className="link_div join_club_div">
                  <h3 className="heading_text">Join The Club</h3>
                  <p className="info_text">
                    Subscribe to receive updates, access to exclusive deals,
                    and more.
                  </p>
                  <form className="subscribe_form" onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      required
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setSubscribeStatus(null);
                      }}
                    />
                    <button type="submit" className="heading">
                      Subscribe
                    </button>
                  </form>
                  {subscribeStatus === "success" && (
                    <p className="subscribe_msg success">
                      Thanks for subscribing!
                    </p>
                  )}
                  {subscribeStatus === "error" && (
                    <p className="subscribe_msg error">
                      Something went wrong, please try again.
                    </p>
                  )}
                </div>
              </div>

              {/* Social Links (far right edge, vertical icons) */}
              <div className="footer_col footer_col_social">
                <div className="link_div social_links_div">
                  <div className="all_icons_holder">
                    {medias?.map((data, index) => {
                      const fullUrl =
                        data.url?.startsWith("http://") ||
                        data.url?.startsWith("https://")
                          ? data.url
                          : `https://${data.url}`;
                      return (
                        <a
                          key={index}
                          href={fullUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="social_icon_holder">
                            <img
                              src={process.env.REACT_APP_IMAGE_URL + data.image}
                              className="social_icon"
                              alt={data.name}
                            />
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="copyrightdiv">
              <p className="cppp">
                &copy; {new Date().getFullYear()} Bapat Optics. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Book_appointment_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      {/* Big map window */}
      <Modal
        show={mapOpen}
        onHide={() => setMapOpen(false)}
        size="xl"
        centered
        dialogClassName="footer_map_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bapat Optics</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <iframe
            className="footer_map_iframe_big"
            title="Bapat Optics location (large)"
            src={bigMapSrc}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Footer;